import superagent from 'superagent'

const setStates = arr => {
  return {
    type: 'SET_STATES',
    payload: arr
  }
}

export const getStates = (token) => (dispatch) => {
  superagent
    .get(`${__API_URI__}/state/get/1`)
    .set('Authorization', `Bearer ${token}`)
    .set('Content-Type', 'application/json')
    .set('Platform', 'Web')
    .set('Version', `${__version__}`)
    .end((err, res) => {
      if (!res) return
      dispatch(setStates(res.body))
    })
}